/** @format */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';

import { Breadcrumb } from '@shared/data-access/interfaces';
import { HmfBreadcrumbsComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { selectBreadcrumbDetails } from '@pdp/data-access/state';

@Component({
	selector: 'pdp-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	imports: [HmfBreadcrumbsComponent]
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
	@Input() categoryId: string;

	breadcrumbs: Breadcrumb[] = [];

	private UNSUBSCRIBE$: Subject<void> = new Subject();

	constructor(private readonly store: Store) {}

	ngOnInit() {
		this.store
			.select(selectBreadcrumbDetails)
			.pipe(
				filter((x) => x != null),
				takeUntil(this.UNSUBSCRIBE$)
			)
			.subscribe((data) => {
				this.breadcrumbs = data;
			});
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}
}
